var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-box',{staticClass:"mb-100"},[_c('notes-default',{attrs:{"noteable":_vm.contact}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }